// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.replay-banner {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1100;
  background: rgba(26, 26, 30, 0.95);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(139, 92, 246, 0.4);
  border-radius: 10px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 200px;
  max-width: 320px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
}

.replay-banner-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.replay-badge {
  background: linear-gradient(135deg, #8b5cf6, #6366f1);
  color: #ffffff;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  padding: 3px 8px;
  border-radius: 4px;
}

.replay-deck-title {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.8rem;
  font-weight: 500;
  line-height: 1.3;
  word-break: break-word;
}

.replay-exit-btn {
  background: transparent;
  border: 1px solid rgba(239, 68, 68, 0.5);
  color: #ef4444;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 4px;
}

.replay-exit-btn:hover {
  background: rgba(239, 68, 68, 0.1);
  border-color: #ef4444;
}
`, "",{"version":3,"sources":["webpack://./src/components/ReplayBanner.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,kCAAkC;EAClC,2BAA2B;EAC3B,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB","sourcesContent":[".replay-banner {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: 1100;\n  background: rgba(26, 26, 30, 0.95);\n  backdrop-filter: blur(12px);\n  border: 1px solid rgba(139, 92, 246, 0.4);\n  border-radius: 10px;\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 200px;\n  max-width: 320px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);\n}\n\n.replay-banner-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.replay-badge {\n  background: linear-gradient(135deg, #8b5cf6, #6366f1);\n  color: #ffffff;\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  padding: 3px 8px;\n  border-radius: 4px;\n}\n\n.replay-deck-title {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 0.8rem;\n  font-weight: 500;\n  line-height: 1.3;\n  word-break: break-word;\n}\n\n.replay-exit-btn {\n  background: transparent;\n  border: 1px solid rgba(239, 68, 68, 0.5);\n  color: #ef4444;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-top: 4px;\n}\n\n.replay-exit-btn:hover {\n  background: rgba(239, 68, 68, 0.1);\n  border-color: #ef4444;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
